import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // Import this
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { importProvidersFrom } from '@angular/core';
import { provideTranslateService, TranslateLoader, TranslateService } from "@ngx-translate/core";
import { provideHttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import Cookies from 'js-cookie';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), importProvidersFrom(BrowserAnimationsModule),
  provideRouter(
    routes,
    withInMemoryScrolling({
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
    })
  ),
  provideHttpClient(),
  provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: httpLoaderFactory,
      deps: [HttpClient]
    }
  }),
  provideAnimationsAsync(), { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }, { provide: MAT_DATE_LOCALE, useValue: 'de-DE' },
  {
    provide: 'APP_INITIALIZER',
    useFactory: (translate: TranslateService) => () => {
      const savedLang = Cookies.get('language') || 'de';  
      translate.setDefaultLang('de');
      translate.use(savedLang);
    },
    deps: [TranslateService],
    multi: true
  }]
};